import React, { useEffect, useState } from 'react'
import "./View.scss";
import Economy_active from '../../assets/image/Economy_active.png'
import Productivity_close from '../../assets/image/Productivity_close.png'
import { Link, useHistory } from "react-router-dom";
import useQuery from '../../components/useQuery'
import html2canvas from 'html2canvas';
import { apiUrl, apiUrl_image } from '../../constants';
import Swal from "sweetalert2";

const View3YC = (props) => {
    const history = useHistory();
    const login_token = useQuery();
    const [token, settoken] = useState(login_token)
    const [snap, setsnap] = useState(0)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const base64toFile = (dataurl, filename) => {
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }


    const saveScreen = async () => {
        await setsnap(1)
        await window.scrollTo(0, 0);
        await html2canvas(document.getElementById("capture")).then(canvas => {
            var dataURL = canvas.toDataURL('image/jpg')
            // console.log(dataURL)
            if (dataURL !== '') {
                var cover = base64toFile(dataURL, "downloadName.jpg");
                sendtoapi(cover)
            }
        })
    }

    const sendtoapi = async file => {

        // var checkcallback = false;
        var token_get = localStorage.getItem('token')
        var cover_token_get = JSON.parse(token_get)
        var formdata = new FormData()
        formdata.append('Files', file, file.name)

        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${cover_token_get}`);
        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow'
        }

        fetch(`${apiUrl}/upload/`, requestOptions)
            .then(response => response.text())
            .then(resu => {
                let res = JSON.parse(resu)
                window.location.href = `callback?path_url=${apiUrl_image}/${res.data}`
                setsnap(0)
                Swal.fire("Report created");

            })
            .catch(error => {
                // console.log('error', error)
                setsnap(0)

            })
    }
    const setDegitSalary = (number) => {
        if (number) {
            var numbers = removeDegitSaraly(number);
            var parts = Number(numbers).toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            let numbera = parts.join(".");
            return numbera;
        } else if (Number(number) === 0) {
            return 0;
        } else {
            return " ";
        }
    };

    const removeDegitSaraly = (number) => {
        if (number) {
            var parts = number.toString().split(".");
            parts[0] = parts[0].replace(",", "");
            let numbera = parts.join(".");
            return numbera;
        } else {
            return " ";
        }
    };

    return (
        <>
            <div id="capture">
                <div className={snap === 1 ? " " : "sticky-headder-result"}>

                    <div className="headder-cal-group-result shadow-result">
                        <div className="d-flex justify-content-between">
                            <div className="container">
                                <div className="row">
                                    <div style={{ paddingTop: "5px", paddingRight: "20px" }} onClick={() =>
                                        history.push(`/History?login_token=${token}`)
                                    }>
                                        <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.35031 0.7256C7.64636 0.4248 8.11244 0.4248 8.40848 0.7256C8.69453 1.01624 8.69453 1.49995 8.40848 1.78991L3.04292 7.24157H19.7485C20.1613 7.24157 20.5 7.57488 20.5 7.99424C20.5 8.4136 20.1613 8.75776 19.7485 8.75776H3.04292L8.40848 14.1992C8.69453 14.5 8.69453 14.9844 8.40848 15.2744C8.11244 15.5752 7.64636 15.5752 7.35031 15.2744L0.714536 8.53216C0.428488 8.24152 0.428488 7.7578 0.714536 7.46784L7.35031 0.7256Z" fill="black" />
                                        </svg>

                                    </div>
                                    <div>
                                        <p style={{ color: "#000", fontSize: "16px" }}>View {props.location.state.events.CustomerName}</p>
                                        <p style={{ color: "#586172", fontSize: "12px", marginTop: "-20px" }}>{props.location.state.comparison_model}</p>
                                    </div>

                                </div>
                            </div>
                            <a style={{ color: "#3b4fbc", fontSize: "16px", textAlign: "right", paddingTop: "5px" }}>
                                {/* <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M17.2703 0C17.6733 0 18 0.32671 18 0.729728V8.51349C18 8.91651 17.6733 9.24322 17.2703 9.24322C16.8673 9.24322 16.5405 8.91651 16.5405 8.51349V2.49145L8.05657 10.9754C7.77159 11.2604 7.30955 11.2604 7.02458 10.9754C6.7396 10.6904 6.7396 10.2284 7.02458 9.94344L15.5086 1.45946H9.48651C9.0835 1.45946 8.75678 1.13275 8.75678 0.729728C8.75678 0.32671 9.0835 0 9.48651 0H17.2703ZM4.62165 2.43243C3.66984 2.43243 3.33708 2.43869 3.08208 2.50702C2.32661 2.70945 1.73652 3.29954 1.53409 4.05501C1.46577 4.31001 1.4595 4.64276 1.4595 5.59458V11.4324C1.4595 12.829 1.46105 13.8031 1.55986 14.538C1.65585 15.2519 1.83142 15.63 2.1007 15.8993C2.36998 16.1686 2.74805 16.3442 3.46199 16.4401C4.19692 16.5389 5.17098 16.5405 6.56759 16.5405H12.4054C13.3572 16.5405 13.69 16.5342 13.945 16.4659C14.7005 16.2635 15.2905 15.6734 15.493 14.9179C15.5613 14.6629 15.5676 14.3302 15.5676 13.3783C15.5676 12.9753 15.8943 12.6486 16.2973 12.6486C16.7003 12.6486 17.027 12.9753 17.027 13.3783L17.027 13.491C17.0273 14.2869 17.0275 14.8299 16.9027 15.2956C16.5653 16.5548 15.5818 17.5382 14.3227 17.8756C13.857 18.0004 13.3139 18.0002 12.5181 18H12.5181L12.4054 18H6.51421C5.18358 18 4.11106 18 3.26752 17.8866C2.39174 17.7688 1.65435 17.5169 1.0687 16.9313C0.483059 16.3456 0.231163 15.6083 0.113419 14.7325C9.53674e-06 13.889 2.47955e-05 12.8164 4.3869e-05 11.4859V11.4858V5.59458L1.90735e-05 5.48193V5.48188C-0.000240326 4.68604 -0.000417709 4.14299 0.124371 3.67727C0.46175 2.41816 1.44523 1.43467 2.70435 1.09729C3.17007 0.972505 3.71313 0.972684 4.50899 0.972946L4.62165 0.97297C5.02467 0.97297 5.35138 1.29968 5.35138 1.7027C5.35138 2.10572 5.02467 2.43243 4.62165 2.43243Z" fill="black" />
                                </svg> */}

                            </a>
                        </div>


                    </div>
                </div>

                {snap === 1 ? null :
                    <div className="container" style={{ marginTop: "90px" }}>
                    </div>
                }
                <div className="container">
                    <div style={{ backgroundColor: "#F6F7FB" }}>

                        <div style={{ marginTop: "5px", backgroundColor: "#fff" }}>
                            <p style={{
                                fontStyle: "normal",
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "17px",
                                color: "#000000",
                            }}>Statistic</p>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row"
                        style={{
                            backgroundColor: "#F9FAFE",
                            borderRadius: "10px",
                            height: "27px"
                        }}
                    >
                        <div className="col-6">

                            <span
                                style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "12px",
                                    lineHeight: "14px",
                                    color: "#3DB3A8",
                                    alignItems: "center",
                                    textAlign: "center",
                                    marginLeft: "3px"
                                }}
                            >

                                Type
                            </span>

                        </div>
                        <div className="col-6" style={{ textAlign: "end" }}>

                            <span
                                style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "12px",
                                    lineHeight: "14px",
                                    color: "#3DB3A8",
                                    alignItems: "center",
                                    textAlign: "center",
                                    marginLeft: "3px"
                                }}
                            >

                                Price
                            </span>

                        </div>
                    </div>
                </div>


                <div className="container">
                    <div className="row"
                        style={{
                            backgroundColor: "#F9FAFE",
                            borderRadius: "10px",
                            marginTop: "5px",
                            height: "49px",
                            alignItems: "center",

                        }}
                    >
                        <div className="col-6">

                            <span
                                style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    marginLeft: "3px",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                Total cost of machine
                            </span>

                        </div>
                        <div className="col-6" style={{ textAlign: "end" }}>

                            <span
                                style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right",
                                    marginLeft: "3px"
                                }}
                            >

                                {setDegitSalary(props.location.state.data.R3YC)} {props.location.state.currency}
                            </span>

                        </div>
                    </div>
                </div>


                <div className="container">
                    <div className="row"
                        style={{
                            backgroundColor: "#F9FAFE",
                            borderRadius: "10px",
                            marginTop: "5px",
                            height: "49px",
                            alignItems: "center",

                        }}
                    >
                        <div className="col-6">

                            <span
                                style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    marginLeft: "3px",
                                    whiteSpace: "nowrap"
                                }}
                            >

                                Total cost after resale machine
                            </span>

                        </div>
                        <div className="col-6" style={{ textAlign: "end" }}>

                            <span
                                style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right",
                                    marginLeft: "3px"
                                }}
                            >

                                {setDegitSalary(props.location.state.data.R3YCResaleCost)} {props.location.state.currency}
                            </span>

                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row"
                        style={{
                            backgroundColor: "#F9FAFE",
                            borderRadius: "10px",
                            marginTop: "5px",
                            height: "49px",
                            alignItems: "center",

                        }}
                    >
                        <div className="col-6">

                            <span
                                style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    marginLeft: "3px",
                                    whiteSpace: "nowrap"
                                }}
                            >

                                Monthly Cost
                            </span>

                        </div>
                        <div className="col-6" style={{ textAlign: "end" }}>

                            <span
                                style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right",
                                    marginLeft: "3px"
                                }}
                            >

                                {setDegitSalary(props.location.state.data.R3YCMonthlyCost)} {props.location.state.currency}
                            </span>

                        </div>
                    </div>
                </div>

                <div style={{ backgroundColor: "#F7F8FB", paddingTop: "5px", marginBottom: "5px", marginTop: "5px" }}>
                </div>

                <div className="container">
                    <div style={{ backgroundColor: "#F6F7FB" }}>

                        <div style={{ marginTop: "10px", backgroundColor: "#fff" }}>
                            <p style={{
                                fontStyle: "normal",
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "17px",
                                color: "#000000",
                            }}>Information</p>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>3YC reference number:</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {props.location.state.events.CustomerName}
                                </p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Model:</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {props.location.state.events.MoDelName}
                                </p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Country:</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {props.location.state.events.Country}

                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />


                <div className="container">
                    <div style={{ backgroundColor: "#F6F7FB" }}>

                        <div style={{ marginTop: "10px", backgroundColor: "#fff" }}>
                            <p style={{
                                fontStyle: "normal",
                                fontWeight: "600",
                                fontSize: "14px",
                                lineHeight: "17px",
                                color: "#000000",
                            }}>Calculation</p>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Lifetime working (h):</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {setDegitSalary(props.location.state.events.LifetimeWork)}
                                </p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Leasing terms (Month):</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {setDegitSalary(props.location.state.events.LeasingTerm)}
                                </p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Price:</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {setDegitSalary(props.location.state.data.Price)} {props.location.state.currency}

                                </p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Resale value (%):</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {setDegitSalary(props.location.state.events.ResaleValue)} %
                                </p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Interest (%):</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {setDegitSalary(props.location.state.events.InterestRate)} %
                                </p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Fuel consumption (L/h):</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {setDegitSalary(props.location.state.events.FuelConsumption)}
                                </p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Fuel price (L):</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {setDegitSalary(props.location.state.events.FuelPrice)} {props.location.state.currency}

                                </p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Maintenance cost (h):</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {setDegitSalary(props.location.state.events.MaintenCost)} {props.location.state.currency}

                                </p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Repair cost (h):</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {setDegitSalary(props.location.state.events.RepairCost)} {props.location.state.currency}

                                </p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "normal",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#737373",
                                }}>Down payment (%):</p>
                                <p style={{
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    lineHeight: "17px",
                                    color: "#14274C",
                                    textAlign: "right"
                                }}>
                                    {setDegitSalary(props.location.state.events.DownPayment)} %
                                </p>
                            </div>

                        </div>
                    </div>
                </div>





                <div className="container" style={{ marginTop: "110px" }}>
                </div>
            </div>


            <div className="sticky-buttom">
                <div className="container">
                    <div>
                        <a
                            className="nav-link active fullwidth"
                            style={{
                                background: "#140A9A",
                                borderRadius: "5px",
                                height: "50px",
                                color: "#fff",
                                paddingTop: "15px"
                            }}
                            onClick={() => saveScreen()}
                        >
                            Create Report
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default View3YC
